<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft">
    <div :class="$style.dropdown">
      <a-avatar
        shape="square"
        icon="user"
        size="large"
        :class="$style.avatar"
      />
    </div>
    <a-menu slot="overlay">
      <a-menu-item>
        <div>
          <strong>
            <!-- {{ $t("topBar.profileMenu.hello") }}, -->
            Welcome,
            {{ auth.fullname || auth.username }}</strong
          >
        </div>
        <div v-if="auth.position && auth.position.name">
          <strong class="mr-1">
            Position:
          </strong>
          {{ auth.position.name }}
        </div>
        <div v-if="auth.department && auth.department.name">
          <strong class="mr-1">
            Department:
          </strong>
          {{ auth.department.name }}
        </div>
        <!-- <div>
          <strong class="mr-1">
            {{ $t("topBar.profileMenu.billingPlan") }} :
          </strong>
          Professional
        </div>
        <div>
          <strong class="mr-1">{{ $t("topBar.profileMenu.role") }}:</strong>
          {{ auth.role }}
        </div> -->
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <div>
          <strong class="mr-1">{{ $t("topBar.profileMenu.email") }}:</strong>
          {{ auth.email }}
        </div>
        <!-- <div>
          <strong class="mr-1">{{ $t("topBar.profileMenu.phone") }}:</strong> -
        </div> -->
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <a href="javascript: void(0);" @click="goTo('myInfo')">
          <i class="fe fe-user mr-2"></i>
          <!-- {{ $t("topBar.profileMenu.editProfile") }} -->
          My info
        </a>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <a href="javascript: void(0);" @click="signOut">
          <i class="fe fe-log-out mr-2"></i>
          <!-- {{ $t("topBar.profileMenu.logout") }} -->
          Log out
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapActions } from "vuex";
const AUTH_TOKEN = process.env.VUE_APP_AUTH_TOKEN_NAME || "apollo-token";
const VUE_APP_SP_HOST = process.env.VUE_APP_SP_HOST;
const VUE_APP_SP_SITE_URL = process.env.VUE_APP_SP_SITE_URL;

export default {
  props: {
    auth: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    ...mapActions({
      logoutAction: "auth/logout",
    }),
    logout() {
      this.logoutAction();
      // this.$router.push("/auth/login");
    },
    goTo(name) {
      if (name) {
        this.$router.push({ name });
      }
    },
    signOut() {
      localStorage.removeItem(AUTH_TOKEN);
      window.location.replace(
        `https://${VUE_APP_SP_HOST}/${VUE_APP_SP_SITE_URL}/login/logout.html?full=true`
      );
    },
  },
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
